import type { ModuleCode, PlanCode } from "./types";

export interface PlanDefinition {
  code: PlanCode;
  name: string;
  monthlyPriceUsd: number;
  conversationLimit: number;
  modules: ModuleCode[];
  isEnterprise: boolean;
  trialDays: number;
  features: string[];
}

export const PLANS: Record<PlanCode, PlanDefinition> = {
  trial: {
    code: "trial",
    name: "Trial",
    monthlyPriceUsd: 0,
    conversationLimit: 100,
    modules: ["faq", "lead_capture", "human_escalation"],
    isEnterprise: false,
    trialDays: 14,
    features: ["14-day trial", "Email support"],
  },
  starter: {
    code: "starter",
    name: "Starter",
    monthlyPriceUsd: 29,
    conversationLimit: 500,
    modules: ["faq", "lead_capture", "human_escalation"],
    isEnterprise: false,
    trialDays: 0,
    features: ["No AI", "Standard support"],
  },
  professional: {
    code: "professional",
    name: "Professional",
    monthlyPriceUsd: 99,
    conversationLimit: 5_000,
    modules: [
      "faq",
      "lead_capture",
      "human_escalation",
      "scheduling",
      "conversational_ai",
      "analytics",
    ],
    isEnterprise: false,
    trialDays: 0,
    features: ["Conversational AI", "Scheduling", "Advanced analytics"],
  },
  enterprise: {
    code: "enterprise",
    name: "Enterprise",
    monthlyPriceUsd: 0,
    conversationLimit: Number.MAX_SAFE_INTEGER,
    modules: [
      "faq",
      "lead_capture",
      "human_escalation",
      "scheduling",
      "conversational_ai",
      "analytics",
      "knowledge_base",
      "integrations",
    ],
    isEnterprise: true,
    trialDays: 0,
    features: [
      "Custom integrations",
      "Document knowledge base (RAG)",
      "Dedicated infrastructure",
      "Advanced RBAC",
      "SLA",
    ],
  },
};

export function planFor(code: string): PlanDefinition | undefined {
  return (PLANS as Record<string, PlanDefinition | undefined>)[code.toLowerCase()];
}

export function isModuleAllowed(planCode: string, moduleCode: ModuleCode): boolean {
  const plan = planFor(planCode);
  if (!plan) return false;
  return plan.modules.includes(moduleCode);
}
